<template>
  <ManySearch />
</template>

<script>
import ManySearch from "@/components/v2/common/views/search/ManySearch.vue";
export default {
    components:{
        ManySearch
    }
}
</script>